const apiUrl = process.env.REACT_APP_API_URL;

export const config = {
  // apiUrl: 'https://paybackendtest.glotelho.cm/api/v1',
  // apiUrlV2: 'https://paybackendtest.glotelho.cm/api/v2',
  // authUrl: 'https://paybackendtest.glotelho.cm/api/v1',
  apiUrl: `${apiUrl}/api/v1`,
  apiUrlV2: `${apiUrl}/api/v2`,
  authUrl: `${apiUrl}/api/v1`,
};
